import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLElement> {
  close(event: Event): void {
    event.preventDefault()
    event.stopPropagation()
    this.element.classList.add('tw-hidden')
  }
}
